import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Input, Select, Textarea } from 'components/fields'
import { Title } from 'components/layout'
import { InfoPanel } from 'components/misc'
import { mapActivitiesCategories } from 'redux/selectors/activities'
import { ACTIVITY_CATEGORIES } from 'constants/enums'
import { AJ_TYPES } from '../../../../constants/enums'

@injectIntl
class AjGeneralInfo extends Component {
  static propTypes = {
    eventTypes: PropTypes.array,
    intl: PropTypes.object,
    activities: PropTypes.object,
    data: PropTypes.object,
    transportationModeList: PropTypes.array,
    awardLevels: PropTypes.array,
    isTemplate: PropTypes.bool,
    onActivityParentChange: PropTypes.func,
    onAjTypeChange: PropTypes.func,
    change: PropTypes.func,
    isCreatedByParticipant: PropTypes.bool,
    isAssessorManagementEnabled: PropTypes.bool,
    ajEvent: PropTypes.object,
    initialize: PropTypes.func
  }
  static defaultProps = {
    isTemplate: false,
    data: {}
  }

  state = {
    changeLocally: false
  }

  componentWillMount = () => {
    const { data } = this.props

    if (get(data, 'activityCategory.userDefined')) {
      this.handleSetOther(data)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
        get(this.props, 'data.activityCategory.parent.id') !==
        get(nextProps, 'data.activityCategory.parent.id')
    ) {
      this.props.onActivityParentChange({
        value: get(nextProps, 'data.activityCategory.parent.id')
      })
    }

    if (
        get(this.props, 'data.activityCategory.id') !==
        get(nextProps, 'data.activityCategory.id') &&
        get(nextProps, 'data.activityCategory.userDefined')
    ) {
      this.handleSetOther(nextProps.data)
    }
  }

  getAwardLevelLock(data) {
    return get(data, 'ajParticipantEvents') && data.ajParticipantEvents.length > 0
  }

  handleSetOther = data => {
    setTimeout(() => {
      this.props.change('otherName', get(data, 'activityCategory.name'))
      this.props.change('activityCategory.id', ACTIVITY_CATEGORIES.other.id)
      this.props.change('activityCategory.userDefined', false)
    }, 0)
  }

  clearAssessorForm = isAssessorManagementEnabled => {

    if(isAssessorManagementEnabled){
      this.props.change('setupAssessorId', null)
      this.props.change('assessorEmail', null)
      this.props.change('assessorPhone', null)
      this.props.change('assessorName', null)
      this.props.change('assessorTitle', null)
    }
  }

  changeActivityParent = () => {
    setTimeout(() => {
      this.props.change('activityCategory.id', null)
    }, 0)
    this.props.onActivityParentChange
  }

  render() {
    const {
      eventTypes,
      activities,
      transportationModeList,
      isTemplate,
      data,
      awardLevels,
      onAjTypeChange,
      intl,
      ajEvent,
      isAssessorManagementEnabled
    } = this.props

    const awardLevelLock = this.getAwardLevelLock(data)

    const mappedActivities = mapActivitiesCategories(
        activities.list,
        null,
        intl.formatMessage({
          id: 'label.other',
          defaultMessage: 'Other'
        })
    )
    const activityCategory = get(ajEvent, 'activityCategory')

    const ajTypesList = get(activities, 'ajTypesList')

    let enhancedAjTypesList = []

    if (activityCategory && ajTypesList && ajTypesList.length > 0) {
      const isNewCategory = get(activityCategory, 'parent.id') ===  AJ_TYPES.VIRTUAL.id || get(activityCategory, 'parent.id') ===  AJ_TYPES.PRACTICAL.id

      enhancedAjTypesList = [...ajTypesList]

      const result = enhancedAjTypesList.filter(ajType => get(ajType, 'id') === get(activityCategory, 'parent.id'))

      if(result.length === 0 && !isNewCategory){
        enhancedAjTypesList.push({
          value: get(activityCategory, 'parent.id'),
          label: get(activityCategory, 'parent.translatedName')
        })
      }

    } else {
      enhancedAjTypesList = [...ajTypesList]
    }



    return (
        <div className="row">
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12">
                <Title h2 intlKey="moduleTitle.adventurous_journey_detail">
                  Journey detail
                </Title>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Input name="title" label="Name" intlKey="label.name" />
              </div>
              <div className="col-xs-6">
                <Select
                    label="Journey category"
                    intlKey="label.journey_category"
                    name="ajEventCategory.value"
                    options={eventTypes}
                    onSelectChange={onAjTypeChange}
                />
              </div>

              <div className="col-xs-6">
                <Select
                  label="Mode of Transport"
                  intlKey="label.mode_of_transport"
                  name="transportationModes"
                  options={transportationModeList}
                  searchable
                  multi
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <Select
                    label="Journey type"
                    intlKey="label.journey_type"
                    name="activityCategory.parent.id"
                    options={enhancedAjTypesList}
                    onSelectChange={this.changeActivityParent}
                />
              </div>
              <div className="col-xs-6">
                <Select
                    label="Journey Activity"
                    intlKey="label.journey_activity"
                    name="activityCategory.id"
                    disabled={
                      (!get(data, 'activityCategory.parent.id') || activities.loading)
                    }
                    options={mappedActivities}
                    searchable
                    onSelectChange={() => this.clearAssessorForm(isAssessorManagementEnabled)}
                />
              </div>
              {get(data, 'activityCategory.id') ===
              ACTIVITY_CATEGORIES.other.id && (
                  <div className="col-xs-6">
                    <Input
                        label="Other activity"
                        intlKey="label.other_activity"
                        name="otherName"
                        maxLength="255"
                    />
                  </div>
              )}
            </div>

            <div className="row">
              <div className="col-xs-6">
                <Select
                    label="Suitable for level"
                    intlKey="label.suitable_for_level"
                    disabled={awardLevelLock}
                    name="awardLevel.value"
                    options={awardLevels}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                {awardLevelLock && (
                    <InfoPanel neutral>
                      <FormattedMessage
                          id="aj.cannot_modify_award_level_if_participants_are_assigned"
                          defaultMessage="The Award Level cannot be modified if participants are assigned to the Adventurous Journey"
                      />
                    </InfoPanel>
                )}
              </div>
            </div>
          </div>

          <div className="col-xs-12">
            <div className="base-margin--top">
              {!isTemplate && (
                  <div className="row">
                    <div className="col-xs-12">
                      <Textarea label="Team Goal" intlKey="label.team_goal" name="aim" />
                    </div>
                  </div>
              )}
              <div className="row">
                <div className="col-xs-12">
                  <Textarea
                      label="Note"
                      intlKey={isTemplate ? 'label.aj_template_note' : 'label.note'}
                      name="note"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }


}

export default AjGeneralInfo
